module.exports = __webpack_public_path__ + "media/images/clearbanc-logo-8f14a7990ccd249c6dc66269f9594604.png";